import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Tab } from '@mui/material';
import { StyledTabs } from '../../../components/styled-tabs/styled-tabs';
import { joinURL } from '../../../utilities/join-url';
import {
  forumAllChatsPathName,
  forumAllChatsTabLabel,
  forumBasePath,
  forumMyChatsPathName,
  forumMyChatsTabLabel,
  forumNewsPathName,
  forumNewsTabLabel,
  forumNudgePathName,
  forumNudgeTabLabel,
  forumSettingsPathName,
  forumSettingsTabLabel,
} from '../forum-area-pathnames';

export const forumMyChatsTabPath = joinURL(forumBasePath, forumMyChatsPathName);
export const forumAllChatsTabPath = joinURL(forumBasePath, forumAllChatsPathName);
export const forumNewsTabPath = joinURL(forumBasePath, forumNewsPathName);
export const forumNudgeTabPath = joinURL(forumBasePath, forumNudgePathName);

export const forumSettingsTabPath = joinURL(forumBasePath, forumSettingsPathName);

export interface IForumCaseworkerTabBarProps {
  showNudgeTab: boolean;
  showSettingsTab: boolean;
}

export function ForumCaseworkerTabBar(props: IForumCaseworkerTabBarProps) {
  const { showNudgeTab, showSettingsTab } = props;
  const history = useHistory();
  const { pathname } = useLocation();

  const handleTabChange = (event: React.ChangeEvent<{}>, newPath: string) => {
    history.push(newPath);
  };

  const tabPaths = [forumMyChatsTabPath, forumAllChatsTabPath, forumNewsTabPath, ...(showNudgeTab ? [forumNudgeTabPath] : []), ...(showSettingsTab ? [forumSettingsTabPath] : [])];
  // MUI logs an error when the value matches no tab, so an unknown path falls back to the first one.
  const selectedTabPath = tabPaths.find(path => path === pathname) ?? forumMyChatsTabPath;

  return (
    <StyledTabs value={selectedTabPath} onChange={handleTabChange}>
      <Tab label={forumMyChatsTabLabel} value={forumMyChatsTabPath} data-vanguard="forum-tab-my-chats" wrapped />
      <Tab label={forumAllChatsTabLabel} value={forumAllChatsTabPath} data-vanguard="forum-tab-all-chats" wrapped />
      <Tab label={forumNewsTabLabel} value={forumNewsTabPath} data-vanguard="forum-tab-news" wrapped />
      {showNudgeTab && <Tab label={forumNudgeTabLabel} value={forumNudgeTabPath} data-vanguard="forum-tab-nudge" wrapped />}
      {showSettingsTab && <Tab label={forumSettingsTabLabel} value={forumSettingsTabPath} data-vanguard="forum-tab-settings" wrapped />}
    </StyledTabs>
  );
}
